import { ref } from '@vue/composition-api'
import customPush from 'custom-push'
import parsePushData from 'custom-push/pushParser/parsePushData'
import parseTopicInfo from 'custom-push/pushParser/parseTopicInfo'
import { subOutcomePush, generateUpdateOutcomes } from './useMarketOutcomes'

const subMarketPush = ({ sportId, categoryId, tournamentId, eventId, marketIds = [] }, callback = null, isSub = true) => {
  // 订阅参数
  const pushOption = {
    type: 2,
    sportId,
    categoryId,
    tournamentId,
    eventId,
    marketIds
  }
  customPush.pushTopic(pushOption, callback, isSub)
}

const getSpecifiers = (topicInfo) => {
  let specifiers = topicInfo.marketSpecifiers
  if (specifiers) {
    // topic中不能出现 |所以specifier多个的情况用&连接，现在在改回去
    specifiers = specifiers.split('&').join('|')
  }
  return specifiers
}

// 更新比赛 market 信息
const generateUpdateMarket =
  (marketMap = {}, getPushTime, updatePushTime) =>
  (data) => {
    const pushData = typeof data === 'string' ? JSON.parse(data) : data
    const marketInfo = parsePushData(pushData, 'market')
    // console.log('push market:', marketInfo)

    if (!marketInfo) return

    const topicInfo = parseTopicInfo(pushData[0], 'market')
    marketInfo.product = +marketInfo.product
    const pushTime = +marketInfo.pushTime
    delete marketInfo.pushTime

    const { marketId } = topicInfo
    const targetMarket = marketMap.value[marketId]
    marketInfo.id = marketId

    // 网络延迟可能导致后收到的数据不是最新的
    const lastPushTime = getPushTime()
    if (lastPushTime && lastPushTime > pushTime) return

    const specifiers = getSpecifiers(topicInfo)

    if (targetMarket) {
      if (specifiers) {
        // specifiers
        const i = targetMarket.findIndex((cur) => cur.specifiers === specifiers)

        if (i > -1) {
          const market = targetMarket[i]
          // 如果当前是 live market，则不合并推送 prematch market 信息
          if (market.product === 1 && marketInfo.product === 3) return
          Object.assign(market, marketInfo)
        } else {
          // 新增 market specifiers
          targetMarket.push({
            specifiers,
            ...marketInfo
          })
        }
      } else {
        // 普通 market
        // 如果当前是 live market，则不合并推送 prematch market 信息
        if (targetMarket.product === 1 && marketInfo.product === 3) return
        Object.assign(targetMarket, marketInfo)
      }
      marketMap.value = Object.assign(marketMap.value, { marketId: targetMarket })
    } else {
      const newMarket = { specifiers, ...marketInfo }
      // 新增 market
      if (specifiers) {
        // specifiers
        marketMap.value = Object.assign(marketMap.value, { marketId: [newMarket] })
      } else {
        // 普通 market
        marketMap.value = Object.assign(marketMap.value, { marketId: newMarket })
      }
    }
    updatePushTime(pushTime)
  }

const convertMarkets = (markets = []) =>
  markets.reduce((obj, market) => {
    const { id, specifiers } = market

    // specifiers
    if (specifiers) {
      if (obj[id]) {
        obj[id].push(market)
      } else {
        obj[id] = [market]
      }
    } else {
      obj[id] = market
    }
    return obj
  }, {})

export default function useMatchMarket({ event, marketIds, isSubMatch }) {
  if (!marketIds || !isSubMatch) return {}
  const { sportId, categoryId, tournamentId, eventId, markets } = event
  const marketMap = ref(convertMarkets(markets || []))
  const marketPushTime = ref(0)
  const getPushTime = () => marketPushTime.value
  const updatePushTime = (pushTime) => {
    marketPushTime.value = pushTime
  }

  const matchOption = {
    sportId,
    categoryId,
    tournamentId,
    eventId,
    marketIds
  }

  const updateMarket = generateUpdateMarket(marketMap, getPushTime, updatePushTime)
  const subMarket = (isSub = true) => subMarketPush(matchOption, updateMarket, isSub)

  const updateOutcomes = generateUpdateOutcomes({ marketMap, getPushTime, updateMarket, updatePushTime })
  const subOutcomes = (isSub = true) => subOutcomePush(matchOption, updateOutcomes, isSub)

  return {
    marketMap,
    subMarket,
    subOutcomes
  }
}
